export const isDeaAdmin = (role) => role === "admin";

export const getIsDeaAdmin = (
  storage = typeof localStorage !== "undefined" ? localStorage : null
) => {
  try {
    return isDeaAdmin(storage ? storage.getItem("dea_role") : null);
  } catch (e) {
    return false;
  }
};

export const normalizeReviewStatus = (status, admin = getIsDeaAdmin()) => {
  const allowedStatuses = ["APPROVED", "REJECTED"];
  if (admin) allowedStatuses.push("APPLY_WAITING");
  return allowedStatuses.includes(status) ? status : "APPROVED";
};

export const normalizeJrReviewStatus = (status, admin = getIsDeaAdmin()) => {
  const allowedStatuses = ["all", "APPROVED", "REJECTED"];
  if (admin) allowedStatuses.push("APPLY_WAITING");
  return allowedStatuses.includes(status) ? status : "all";
};
